import { goToLink } from "@actions/common.js";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import ArrowDownIcon from "../../../../assets/icons/ArrowDownIcon.jsx";
import BonusesIcon from "../../../../assets/icons/BonusesIcon.jsx";
import DocumentsIcon from "../../../../assets/icons/DocumentsIcon.jsx";
import HistoryIcon from "../../../../assets/icons/HistoryIcon.jsx";
import MoneyIcon from "../../../../assets/icons/Money.jsx";
import NotificationIcon from "../../../../assets/icons/NotificationIcon.jsx";
import ProfileIcon from "../../../../assets/icons/ProfileIcon.jsx";
import WithdrawIcon from "../../../../assets/icons/Withdraw.webp";
import { menuItems } from "../../../../constants/index.js";
import { DropdownWrapper, HeaderText, StyledMenu, StyledMenuItem } from "./elements.js";

const DropdownMenu = ({ goToLink, location, translate }) => {
	const [selectedItem, setSelectedItem] = useState(menuItems[0].text);
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const dropdownRef = useRef(null);

	const handleMenuClick = (item) => {
		setSelectedItem(item.text);
		goToLink(item.link);
		setIsDropdownOpen(false);
	};

	useEffect(() => {
		const pathToIndexMap = {
			"/profile/settings": 0,
			"/profile/inbox": 1,
			"/profile/history": 2,
			"/profile/documents": 3,
			"/profile/bonuses": 4,
			"/profile/deposit": 5,
			"/profile/withdraw": 6,
		};

		const index = pathToIndexMap[location.pathname];
		if (index !== undefined) {
			setSelectedItem(menuItems[index].text);
		}
	}, [location.pathname]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsDropdownOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const iconMap = {
		"Profile": <ProfileIcon color="#F7F7F7" />,
		"Notifications": <NotificationIcon />,
		"History": <HistoryIcon />,
		"Documents": <DocumentsIcon />,
		"My Bonuses": <BonusesIcon />,
		"Deposit": <MoneyIcon />,
		"Withdraw": <img src={WithdrawIcon} />,
	};

	const filteredMenuItems = () => {
		if (location.pathname === "/profile/deposit" || location.pathname === "/profile/withdraw") {
			return menuItems.filter((item) => item.text === "Deposit" || item.text === "Withdraw");
		} else {
			return menuItems.filter((item) => item.text !== "Deposit" && item.text !== "Withdraw");
		}
	};

	return (
		<div ref={dropdownRef}>
			<DropdownWrapper
				isDropdownOpen={isDropdownOpen}
				rotate={isDropdownOpen}
				onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
				{iconMap[selectedItem]}
				<HeaderText>{translate(selectedItem)}</HeaderText>
				<ArrowDownIcon />
			</DropdownWrapper>
			{isDropdownOpen && (
				<StyledMenu>
					{filteredMenuItems()?.map((item) =>
						item.text !== selectedItem ? (
							<StyledMenuItem
								key={item.key}
								onClick={() => handleMenuClick(item)}>
								{iconMap[item.text]}
								{translate(item.text)}
							</StyledMenuItem>
						) : null
					)}
				</StyledMenu>
			)}
		</div>
	);
};

const mapStateToProps = () => ({});

const mapDispatchToProps = { goToLink };

export default connect(mapStateToProps, mapDispatchToProps)(DropdownMenu);
